import { AuthCatcher } from '../../components/AuthCatcher'
import { AfterCatchersAreSet } from './AfterCatchersAreSet'

export const RouterWrappers = () => (
  <AuthCatcher>
    <AfterCatchersAreSet />
  </AuthCatcher>
)
